(function() {
    'use strict';

a3_cabin_reports.factory('httpCrewTokenInterceptor', httpCrewTokenInterceptor);

    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name httpCrewTokenInterceptor
    * @description 
    *  Add CrewToken on non login requests
    * @ngInject
    */
function httpCrewTokenInterceptor($location, localStorageMD5Service,UserTokenFactory) {
		return {
			request: function(config) {
                if ($location.$$url != "/login") {

					// get the user token
					var user = localStorageMD5Service.get('user');
					var token = '';
					if (user != null)
						token = user.token;

					config.headers['X-CrewToken'] = token;
				}
				return config;
			},
            response: function (response) {
                if(response.headers()['content-type'] === "application/json; charset=utf-8"){
                  
                        var expiresAt = response.headers()['x-expires-token']
                        var crewToken = response.headers()['x-rolling-token']

                      if(expiresAt && crewToken ){
                       var user = localStorageMD5Service.get('user');
                        if (user != null){
                             user.token = crewToken;
                             user.expires = expiresAt;
                             localStorageMD5Service.set('user',user);
                        }
                         UserTokenFactory.setToken(crewToken);

                      }
                }
                return response;
            }

		};
	}

})();